module.exports = __webpack_public_path__ + "img/offline-2d-3d-integration.7609d5f8.webp";